import { styled } from '../../../hooks/theme';
import { getCssFont } from '../../../styles';
import { Tokens } from '../../../types';

export const H1 = styled.h1`
  ${props => {
    const font = props.theme.font.desktop.heading.h1.bold;
    return getCssFont(font);
  }};

  @media screen and (max-width: ${Tokens.breakpoints.mobile}px) {
    ${props => {
      const font = props.theme.font.mobile.heading.h1.bold;
      return getCssFont(font);
    }};
  }
`;
H1.defaultProps = {
  theme: Tokens.eixods,
};

export const H2 = styled.h2`
  ${props => {
    const font = props.theme.font.desktop.heading.h2.bold;
    return getCssFont(font);
  }};
  @media screen and (max-width: ${Tokens.breakpoints.mobile}px) {
    ${props => {
      const font = props.theme.font.mobile.heading.h2.bold;
      return getCssFont(font);
    }};
  }
`;
H2.defaultProps = {
  theme: Tokens.eixods,
};

export const H3 = styled.h3`
  ${props => {
    const font = props.theme.font.desktop.heading.h3.bold;
    return getCssFont(font);
  }};
  @media screen and (max-width: ${Tokens.breakpoints.mobile}px) {
    ${props => {
      const font = props.theme.font.mobile.heading.h3.bold;
      return getCssFont(font);
    }};
  }
`;
H3.defaultProps = {
  theme: Tokens.eixods,
};

export const H4 = styled.h4`
  ${props => {
    const font = props.theme.font.desktop.heading.h4.bold;
    return getCssFont(font);
  }};
  @media screen and (max-width: ${Tokens.breakpoints.mobile}px) {
    ${props => {
      const font = props.theme.font.mobile.heading.h4.bold;
      return getCssFont(font);
    }};
  }
`;
H4.defaultProps = {
  theme: Tokens.eixods,
};
